export {};

document.addEventListener('started', () => {
    mountGalleries();
});

function mountGalleries(): void {
    if (typeof Splide === 'undefined') {
        return;
    }

    app.html.qAll('.splide.gallery').forEach(gallery => {
        const galleryId = +app.html.getData(gallery, 'galleryId');
        app.image.renderGallery(galleryId);
    });
}
